module.exports = __webpack_public_path__ + "static/monkeybars800x600-9e96a24dcc44debd2505f0642aab1799.jpeg";